import { useMutation, useQueryClient } from '@tanstack/react-query';

import { baseAPI } from '~shared/api/base-api';
import { KEYS } from '~shared/api/query-keys';

interface DeleteHourlyTuitionBillingParams {
  id: string;
}

export const deleteHourlyTuitionBilling = async (
  params: DeleteHourlyTuitionBillingParams,
) => {
  const response = await baseAPI.delete<{ success: boolean }>(
    `/hourly-tuition-billing/${params.id}`,
  );
  return response.data;
};

export const useDeleteHourlyTuitionBilling = () => {
  const queryClient = useQueryClient();

  return useMutation<
    { success: boolean },
    Error,
    DeleteHourlyTuitionBillingParams
  >({
    mutationFn: deleteHourlyTuitionBilling,
    onSuccess: (_, params) => {
      void queryClient.invalidateQueries({
        queryKey: [KEYS.HOURLY_TUITION_BILLING],
      });
      void queryClient.invalidateQueries({
        queryKey: [KEYS.HOURLY_TUITION_BILLING, params.id],
      });
    },
  });
};
